import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

import { LineItem } from 'src/app/models/line-item.model';
import { Order } from 'src/app/models/order.model';

@Component({
  selector: 'line-item-list-display',
  templateUrl: './line-item-list-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, MatIconModule, DatePipe, RouterLink],
})
export class LineItemListDisplayComponent {
  @Input() order: Order;

  @Input() lineItem: LineItem;

  @Input() isSelected: boolean;
}
